import SplitText from "@/lib/gsap-plugins/SplitText.min.js";
import ScrollSmoother from "@/lib/gsap-plugins/ScrollSmoother.min.js";
import EffectCarousel from "@/lib/swiper-modules/effect-carousel.min.js"
import EffectMaterial from "@/lib/swiper-modules/effect-material"
import EffectSlicer from "@/lib/swiper-modules/effect-slicer.min.js";

export { SplitText, ScrollSmoother, EffectCarousel, EffectMaterial, EffectSlicer };

